export default __webpack_public_path__ + "assets/img/az.ffc79bf.svg";